<div
  class="w-full rounded-lg shadow-xs outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode flex flex-col justify-start items-start overflow-hidden"
>
  <div class="flex flex-col w-full h-full">
    <div class="pt-5 px-6 flex gap-4 justify-between items-center">
      <div
        class="flex-1 text-on-surface dark:text-on-surface-darkmode font-semibold leading-6 line-clamp-1"
      >
        <ui-skeleton class="block h-3 w-[80px] rounded-full" />
      </div>
      <ui-skeleton class="h-8 w-[100px] rounded-md" />
    </div>
    <div class="flex justify-center items-center w-full py-10">
      <div
        class="w-60 max-w-60 max-h-60 p-5 bg-surface rounded-2xl aspect-square flex items-center justify-center"
      >
        <!-- inline svg to prevent loading delays in a loading skeleton -->
        <svg
          width="121"
          height="128"
          viewBox="0 0 121 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="animate-pulse w-36 block"
        >
          <path
            d="M31.0554 45.1909C28.3095 40.4409 31.7373 34.5 37.2238 34.5H61.8789C64.4251 34.5 66.7778 35.8588 68.0503 38.0642L89.2095 74.736C91.9502 79.486 88.5221 85.4219 83.0381 85.4219L58.4235 85.4219C55.8794 85.4219 53.5283 84.0654 52.2551 81.8628L31.0554 45.1909Z"
            fill="#E2E8F0"
          />
          <path
            d="M111.125 34.875C116.303 34.875 120.5 39.0723 120.5 44.25V110.625C120.5 115.803 116.303 120 111.125 120H46.0625C41.1955 120 37.25 116.055 37.25 111.188C37.25 106.32 41.1955 102.375 46.0625 102.375H75.875C76.163 102.375 76.448 102.361 76.7294 102.336H98.1597C107.264 102.336 112.955 92.457 108.405 84.5515L85.25 44.3188V44.25C85.25 39.0723 89.4473 34.875 94.625 34.875H111.125Z"
            fill="#E2E8F0"
          />
          <path
            d="M9.875 85.125C4.69733 85.125 0.5 80.9277 0.5 75.75V9.375C0.5 4.19733 4.69733 0 9.875 0H74.9375C79.8045 1.18382e-06 83.75 3.94549 83.75 8.8125C83.75 13.6795 79.8045 17.625 74.9375 17.625H45.125C44.837 17.625 44.552 17.6388 44.2706 17.6642H22.8403C13.7363 17.6642 8.04507 27.543 12.5948 35.4485L35.75 75.6812V75.75C35.75 80.9277 31.5527 85.125 26.375 85.125H9.875Z"
            fill="#E2E8F0"
          />
        </svg>
      </div>
    </div>
    <div
      class="py-4.5 px-6 flex gap-5 border-t border-outline dark:border-outline-darkmode items-center"
    >
      <div
        class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm leading-5 font-normal line-clamp-1 flex-1"
      >
        <ui-skeleton class="block h-3 w-[120px] rounded-full" />
      </div>
      <ui-skeleton class="block h-5 w-[80px] rounded-full" />
    </div>
  </div>
</div>
